import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, of } from 'rxjs';
import { catchError, map, tap } from 'rxjs/operators';
import { Api } from './api';
import { ApiService } from 'src/app/services/api.service';
import { LocalStorageCryptoService } from './localStorageCrypto.service';
import { NavController } from '@ionic/angular';
import { ProfileUser } from '../pages/models/profile-user.interface';
import { LocalStorageService } from './localStorage.service';
import { account } from '..';
import { User } from '../models/user.model';
import { UserDetailService } from './user-details.service';
import { UserDetail } from '../models/user-details.model';
import { ProfilePicture } from '../models/profile-picture.model';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  private authSubject = new BehaviorSubject<boolean>(false);
  private tokenKey = 'jwt_token';
  private userSubject = new BehaviorSubject<ProfileUser | null>(null); 
  user$ = this.userSubject.asObservable();
  environment: any;
  account = account;

  private userDetailSubject = new BehaviorSubject<UserDetail | null>(null);
  userDetail$ = this.userDetailSubject.asObservable();

  private userProfilePictureSubject = new BehaviorSubject<ProfilePicture | null>(null);
  userProfilePicture$ = this.userProfilePictureSubject.asObservable();

    constructor(private api: Api, private apiService:ApiService, public localStore: LocalStorageCryptoService, private navCtrl: NavController, private localStorageService:LocalStorageService,
     private userDetailService: UserDetailService
  ) {
     this.loadUserFromStorage(); // **Uygulama açıldığında localStorage’den kullanıcıyı yükle**

  }

  login(credentials: { username: string; password: string }, isRemember: boolean = false): Observable<any> {
    return this.api.post("/authenticate", credentials).pipe(map(async response => {
      this.localStore.saveData(this.tokenKey, response.id_token);
      this.localStore.saveData("isRemember", isRemember.toString());
      this.authSubject.next(true);
      return response;
    }));
  }
    login2(credentials: { username: string; password: string }, isRemember: boolean = false): Observable<any> {
    return this.api.post("/authenticate", credentials).pipe(
      map(response => {
        console.log("🔹 API’den Gelen Response (Login):", response); 

        if (response?.id_token) {
          this.localStore.saveData(this.tokenKey, response.id_token);
          this.localStore.saveData("isRemember", isRemember.toString());
          this.account.token = response.id_token;
          this.authSubject.next(true);

          this.getAllAccount().subscribe();

          console.log("🔹 login() - Kullanıcı Bilgileri Yükleniyor...");
        }
        return response;
      })
    );
  }
forgotPassword(email: string): Observable<any> {
  return this.api.post("/account/reset-password/init", email );
}

resetPassword(key: string, newPassword: string): Observable<any> {
  return this.api.post("/account/reset-password/finish", { 
    key: key,  
    newPassword: newPassword
  });
}
changePassword (currentPassword: string, newPassword: string) {
  return this.api.post("/account/change-password",{
    currentPassword,
    newPassword
  });
}

  getAllAccount(): Observable<ProfileUser> {
    return this.apiService.getAccount().pipe(
      map(data => {
        console.log("🔹 getAllAccount() - Kullanıcı Bilgileri API'den Alındı:", data);

        if (data) {
          this.localStorageService.setItem('user', JSON.stringify(data));
          this.loadUserDetails(data.id)
          this.getUserProfilePicture(data.id);
          this.userSubject.next(data); 
        }
        return data;
      })
    );
  }
  

async logout() {

  localStorage.removeItem('jwt_token');
  localStorage.removeItem('isRemember');
  localStorage.removeItem('selectedPackage');
  localStorage.removeItem('user');

  this.authSubject.next(false);
  this.userSubject.next(null);
  this.environment.user = null;
  this.account.token = '';
  this.account.userData = new User();

  await new Promise(resolve => setTimeout(resolve, 500));

}


  async getToken(): Promise<string | null> {
      console.log('getToken çağrıldı');  // Bunu ekle ve console’da kaç defa çağrıldığını kontrol et

    const token = await this.localStore.getData(this.tokenKey);
    return token;
  }

  isAuthenticated(): Observable<boolean> {
    const token = this.localStore.getData(this.tokenKey);
    if(token!=null && token!=undefined && token!=""){
      this.authSubject.next(true);
    }else{
      this.authSubject.next(false);
    }

    return this.authSubject.asObservable();
  }


    getUser(): ProfileUser | null {
    return this.userSubject.value;

  }

  private loadUserFromStorage() {
    const storedUser = this.localStorageService.getItem('user');
    console.log("🔹 loadUserFromStorage() - LocalStorage’den Gelen Kullanıcı:", storedUser); 

    if (storedUser) {
      try {
        const userData = JSON.parse(storedUser) as ProfileUser;
        this.userSubject.next(userData); // **BehaviorSubject’i güncelle**
        console.log("🔹 loadUserFromStorage() - Güncellenmiş userSubject:", this.userSubject.value);
      } catch (error) {
        console.error("❌ LocalStorage'teki user verisi parse edilemedi!", error);
      }
    }
  }

  async getUserProfilePicture(userId: number): Promise<void> {
    try {
      const imageUrl = await this.userDetailService
        .getProfilePicture(userId)
        .toPromise();
  
      if (!imageUrl) {
        this.userProfilePictureSubject.next(null);
        return;
      }
  
      const profilePicture = new ProfilePicture({
        userId: userId,
        base64Image: imageUrl 
      });
  
      this.userProfilePictureSubject.next(profilePicture);
      this.saveUserProfilePictureToStorage(profilePicture);
  
    } catch (error) {
      console.error('Profil resmi yüklenirken hata oluştu:', error);
      this.userProfilePictureSubject.next(null);
    }
  }
  

  private saveUserProfilePictureToStorage(picture: ProfilePicture | null): void {
    if (picture) {
      this.localStorageService.setItem('userProfilePicture', JSON.stringify({
        userId: picture.userId,
        base64Image: picture.base64Image
      }));
    } else {
      this.localStorageService.removeItem('userProfilePicture');
    }
  }

  async loadUserDetails(userId: number) {
    try {
      const response = await this.userDetailService
        .getUserDetailsByUserId(userId)
        .toPromise();

      const details: UserDetail[] = Array.isArray(response) ? response : (response ? [response] : []);
      const userDetail = details[0] ?? null;
      this.userDetailSubject.next(userDetail);
      this.saveUserDetailToStorage(userDetail);
    } catch (error) {
      console.error('Kullanıcı detay bilgileri yüklenirken hata oluştu:', error);
    }
  }

  private saveUserDetailToStorage(detail: UserDetail | null): void {
    if (detail) {
      this.localStorageService.setItem('userDetail', JSON.stringify(detail));
    } else {
      this.localStorageService.removeItem('userDetail');
    }
  }

  updateUserProfilePicture(picture: ProfilePicture | null): void {
    this.userProfilePictureSubject.next(picture);
    this.saveUserProfilePictureToStorage(picture);
  }
fetchUserData(): Observable<void> {
  const userId = this.userSubject.value?.id;

  if (!userId) {
    return of(void 0); // user yoksa
  }

  return this.getAllAccount().pipe(
    tap(user => {
      this.userSubject.next(user);
      this.loadUserDetails(userId);
      this.getUserProfilePicture(userId);
    }),
    map(() => void 0)
  );
}
  updateCurrentUser(id: number, user: Partial<User>): Observable<User> {
    return this.api.postGenerate('/account', user);
  }
}
